// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__lwi_L","messages":"Chat_messages__34HZv","dateDivider":"Chat_dateDivider__25UE9"};